export const TIPS_INFO = {
  PAID_WITH_SALARY: 'Tips are paid out with salary',
  NO_TIPS: 'No tips',
}

export const TIMEZONE = 'Europe/Oslo'

export const currentVersion = `${process.env.REACT_APP_BRANCH_NAME}-${process.env.REACT_APP_COMMIT_HASH}`
